import { useTranslation } from 'react-i18next'

// The @components barrel re-exports CreateContactModal, which renders this section through the create-supplier modal.
// Moving the supplier modal out of views/ does not fix this; it can import from @components again once the barrel
// stops re-exporting CreateContactModal and ContactSelect (EXP-660).
// eslint-disable-next-line @billy/shine-accounting/consistent-alias-imports -- importing the barrel from here cycles back through CreateContactModal
import { CountryDropdown } from '../../../../../../../../../../../../../../components/selects/CountryDropdown/CountryDropdown'
import { DesignSystem } from '../../../../../../../../../../../../../../enums/designSystem'
import { useFormContext } from '../../../../../../../../../../../../../../hooks/useForm'
import type { SupplierFormSchema } from '../../../../../../types/supplierForm'

export const CompanyCountry = () => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<SupplierFormSchema, DesignSystem.Lumen>({ designSystem: DesignSystem.Lumen })

  return (
    <FormItem
      name="countryId"
      render={({ error, field }) => (
        <CountryDropdown
          countryId={field.value}
          error={error}
          label={t('suppliers.detail.form.country.label')}
          onSelect={field.onChange}
        />
      )}
    />
  )
}
